const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Bun venit în BRIDGESTONE PLUS",
      content:
        "Stimate,<br/>Bun venit! Suntem bucuroși să vă informăm că, începând de astăzi, puteți accesa gratuit BRIDGESTONE PLUS și naviga prin toate aplicațiile Bridgestone la care aveți deja acces.<br/>În speranța de a dezvolta și mai mult colaborarea noastră vă invităm să explorați toate funcționalitățile BRIDGESTONE PLUS. Nu ezitați să ne contactați dacă aveți întrebări sau nevoie de informații suplimentare.<br/>Cu sinceritate,<br/>Echipa Bridgestone",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Bun venit în BRIDGESTONE PLUS",
      content:
        "Stimate,<br/>Bun venit! Suntem bucuroși să vă informăm că, începând de astăzi, puteți accesa gratuit BRIDGESTONE PLUS și naviga prin toate aplicațiile Bridgestone la care aveți deja acces.<br/>În speranța de a dezvolta și mai mult colaborarea noastră vă invităm să explorați toate funcționalitățile BRIDGESTONE PLUS. Nu ezitați să ne contactați dacă aveți întrebări sau nevoie de informații suplimentare.<br/>Cu sinceritate,<br/>Echipa Bridgestone",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
